import React from 'react';

const AccordionSection = ({ isOpen, onToggle, title, children, iconName = 'document-text-outline' }) => (
    <div className="accordion mt-1">
        <h2 className="accordion-header">
            <button className={`accordion-button${isOpen ? '' : ' collapsed'}`} onClick={onToggle} type="button" aria-expanded={isOpen}>
                <strong>
                    <ion-icon name={iconName} class="fl md hydrated" />
                    {title}
                </strong>
            </button>
        </h2>
        {isOpen &&
            <div className="accordion-collapse collapse show">
                <div className="accordion-body pb-0 pt-0">
                    {children}
                </div>
            </div>}
    </div>
);

export default AccordionSection;
